<template>
    <table class="table table-hover m-0">
        <thead>
        <tr>
            <th class="w-450px">{{ __('general.article') }}</th>
            <th>{{ identifierType.toUpperCase() }}</th>
            <th v-if="inStoreArticleIdExists">
                {{ __('orders.details.refund.item_store_id') }}
            </th>
            <th class="text-center" :class="{'text-danger': emptyRefund}">
                {{ __('general.quantity') }}
            </th>
            <th v-if="!isAmazonTodayOrder" class="text-right">
                {{ __('general.purchase_price') }}
            </th>
            <th v-if="refundMode" class="text-right">
                {{ __('general.purchase_refund') }}
            </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in order.items">
            <td>
                <div class="d-flex flex-row">
                    <div>
                        <img v-if="item.image_url"
                             :src="item.image_url"
                             alt="Artikelbild"
                             class="rounded"
                             style="object-fit:cover; height: 52px; width: 52px;">
                        <span v-else class="bg-light rounded" style="height: 52px; width: 52px;"/>
                    </div>
                    <div class="pl-3">
                        <span>{{ item.title }}</span>
                        <div v-if="showDescription" class="text-xs font-weight-lighter">
                            {{ item.description }}
                        </div>
                    </div>
                </div>
            </td>
            <td>{{ item.identifier }}</td>
            <td v-if="inStoreArticleIdExists">
                {{ item.in_store_article_id }}
            </td>
            <td class="text-center">
                <div v-if="refundMode">
                    <div class="d-flex justify-content-center">
                        <div class="d-flex">
                            <div class="w-75px">
                                <input class="form-control text-center text-lg"
                                       :class="{'border-danger': emptyRefund}"
                                       type="number"
                                       :value="value.hasOwnProperty(item.identifier) ? value[item.identifier] : item.quantity"
                                       :min="0"
                                       :max="item.quantity"
                                       @input="e => updateQuantity(item, e.target.value)"
                                >
                            </div>
                            <div class="d-flex flex-column justify-content-center">
                                <div class="text-lg ml-2" :class="{'text-danger': emptyRefund}">
                                    {{ __('general.of') }}&nbsp;<b>{{
                                        item.quantity
                                    }}</b>&nbsp;{{ __('general.pieces_short') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>{{ item.quantity }} {{ __('general.pieces_short') }}</div>
            </td>
            <td v-if="!isAmazonTodayOrder" class="text-right">
                {{ item.price.toFixed(2) }}
                <CurrencySymbol :currency="currency"/>
            </td>
            <td v-if="refundMode" class="text-right">
                {{ (item.price * (value[item.identifier] / item.quantity)).toFixed(2) }}
                <CurrencySymbol :currency="currency"/>
            </td>
        </tr>
        <tr v-if="showTotal && shippingCost > 0" class="border-top border-2 border-light-dark">
            <td>{{ __('general.shipping_cost_included') }}</td>
            <td :colspan="inStoreArticleIdExists ? 2 : 1"></td>
            <td class="text-center"></td>
            <td class="text-right">
                {{ shippingCost.toFixed(2) }}
                <CurrencySymbol :currency="currency"/>
            </td>
        </tr>
        <tr v-if="showTotal" class="font-weight-bold border-top border-light-dark">
            <td>{{ __('general.total') }}</td>
            <td :colspan="inStoreArticleIdExists ? 2 : 1"></td>
            <td class="text-center">{{ order.items_count }} {{ __('general.pieces_short') }}</td>
            <td class="text-right">
                {{ order.total.toFixed(2) }}
                <CurrencySymbol :currency="currency"/>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
import {IntegrationCodeEnum} from "@generated/integrationCodeEnum";
import CurrencySymbol from "@components/CurrencySymbol.vue";

export default {
    components: {CurrencySymbol},

    props: {
        value: Object,
        order: Object,
        shippingCost: Number,
        showTotal: {
            type: Boolean,
            default: true,
        },
        showDescription: {
            type: Boolean,
            default: false,
        },
        refundMode: {
            type: Boolean,
            default: false,
        },
        emptyRefund: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        updateQuantity(item, newQuantity) {
            newQuantity = parseInt(newQuantity)

            if (newQuantity < 0) {
                newQuantity = 0
            } else if (newQuantity > item.quantity) {
                newQuantity = item.quantity
            }

            let newSelection = _.cloneDeep(this.value)
            newSelection[item.identifier] = newQuantity
            this.$emit('input', newSelection)
        },
    },

    computed: {
        IntegrationCodeEnum() {
            return IntegrationCodeEnum
        },

        inStoreArticleIdExists() {
            return this.order.items.some(item => item.in_store_article_id !== null)
        },

        isAmazonTodayOrder() {
            return this.order.integration.code === IntegrationCodeEnum.AmazonTODAY
        },

        currency() {
            return this.order.items[0].currency;
        },

        identifierType() {
            return this.order.items[0].identifier_type;
        }
    },
}
</script>
